import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class ordersStatistics extends Vue {
  @Prop({ default: "Statistiche ordini" })
  title: string;
}
